'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _EmojiMart = require('./EmojiMart.style');

var _EmojiMart2 = _interopRequireDefault(_EmojiMart);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function (theme) {
  var EmojiMartTheme = (0, _EmojiMart2["default"])(theme);
  return (0, _assign2["default"])({}, EmojiMartTheme, {
    emoji: {
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      '&.hidden': {
        display: 'none'
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      }
    },
    picker: {
      zIndex: 10,
      position: 'absolute',
      '&.hidden': {
        display: 'none'
      }
    }
  });
};